var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents_wrapper"},[_c('div',{staticClass:"contents"},[_c('AboutTableBlock'),_c('h2',{staticClass:"large_black_label",attrs:{"id":"service"}},[_vm._v("創業のきっかけ")]),_c('AboutSectionBlock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }